import React from "react";
import { Box, Button, Drawer } from "@mui/material";
import { ProjectTable } from "./ProjectTable";
import { Icon } from "@iconify/react";
export const ProjectTableDrawer = ({ open, onClose, activeNodeId, isMobile, parentProjectNumber, childProjectNumber, projectName, unitType, projectId, nodeDepth, }) => {
    return (React.createElement(Drawer, { anchor: "bottom", open: isMobile && open && !!activeNodeId, onClose: onClose, sx: {
            "& .MuiDrawer-paper": {
                height: "80vh",
                // borderTopLeftRadius: 16,
                // borderTopRightRadius: 16,
                padding: 2,
            },
        } },
        React.createElement(Box, { sx: {
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            } },
            React.createElement(Box, { sx: { fontSize: 18, fontWeight: 600 } }, "Projectgegevens"),
            React.createElement(Button, { variant: "text", color: "inherit", onClick: onClose, sx: { minWidth: "auto", p: 1, fontSize: 24 } },
                React.createElement(Icon, { icon: "mingcute:close-line", width: "18", height: "18" }))),
        activeNodeId && (React.createElement(Box, { sx: { mb: 1, p: 1, backgroundColor: "#f5f5f5", borderRadius: 1 } },
            React.createElement(Box, { sx: { fontSize: 12, color: "text.secondary" } }, "Geselecteerd knooppunt:"),
            React.createElement(Box, { sx: { fontSize: 14, fontWeight: 500 } }, activeNodeId))),
        React.createElement(Box, { sx: { overflow: "auto", flex: 1 } },
            React.createElement(ProjectTable, { parentProjectNumber: parentProjectNumber, childProjectNumber: childProjectNumber, projectName: projectName, unitType: unitType, projectId: projectId, nodeDepth: nodeDepth }))));
};
